module.exports = __webpack_public_path__ + "img/hospital.e903ffd8.svg";